//* 公共函数
import { Formats } from "@/assets/js";
//* 组件属性
import type { NewsData } from "../index";
export const useComposable = () => {
    //* route
    const route = useRoute();

    //* 路由映射
    const types_map: Record<string, string> = {
        genetic: "Genetic Encyclopedia",
        frontier: "Frontiers",
        insight: "Industry Insights",
        case: "Case Studies",
    };

    //* 响应式数据
    const refs = {
        loading: ref<boolean>(false),
        page: ref<number>(1),
        limit: ref<number>(8),
        count: ref<number>(0),
        data: ref<NewsData[]>([]),
        filter: ref<string>(types_map[Formats.query(route.params.type)] || "All"),
        keyword: ref<string>(""),
    };

    //* 函数列表
    const methods = {
        //* 获取数据
        acquire: (number?: number) => {
            //* 数据更新
            refs.loading.value = true;
            refs.page.value = number || refs.page.value;
            //* 接口请求
            api.frontend(`/api/news/search`, {
                method: "POST",
                data: {
                    keyword: refs.keyword.value,
                    page: refs.page.value,
                    type: refs.filter.value,
                    limit: refs.limit.value,
                },
                success: (response) => {
                    refs.count.value = response.count;
                    refs.page.value = response.page;
                    refs.data.value = response.data;
                    window.scrollTo({ top: 0, behavior: "smooth" });
                },
                finally: () => (refs.loading.value = false),
            });
        },
    };

    return { refs, methods };
};
